import { render, staticRenderFns } from "./foot.vue?vue&type=template&id=63db2cd8&scoped=true&"
var script = {}
import style0 from "./foot.vue?vue&type=style&index=0&id=63db2cd8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63db2cd8",
  null
  
)

export default component.exports